<template>
  <div class="app-container" id="main">
    <div class="search-old-settlement-detail">
      <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      center
    >
      <el-table-column
        label="工单编号"
        prop="sourceWorkOrderNo"
      ></el-table-column>
      <el-table-column
        label="工单类型"
        prop="serviceTypeName"
      ></el-table-column>
      <el-table-column
        label="内机条码"
        prop="oldInternalBarcode"
      ></el-table-column>
      <el-table-column
        label="外机条码"
        prop="oldExternalBarcode"
      ></el-table-column>
      <el-table-column
        label="回收订单"
        prop="sendBackOrderId"
      ></el-table-column>
      <el-table-column
        label="完成时间"
        prop="recoveryCompleteDateName"
      ></el-table-column>
      <el-table-column
        label="渠道来源"
        prop="salePlatformName"
      ></el-table-column>
      <el-table-column
        label="网点编号"
        prop="outletsNo"
      ></el-table-column>
      <el-table-column
        label="承运商"
        prop="transportCompany"
      ></el-table-column>
      <el-table-column
        label="归集仓"
        prop="warehouseName"
      ></el-table-column>
      <el-table-column
        label="省"
        prop="warehouseAddrProvName"
      ></el-table-column>
      <el-table-column
        label="市"
        prop="warehouseAddrCityName"
      ></el-table-column>
      <el-table-column
        label="旧机品牌(物流)"
        prop="appraisalBrand"
      ></el-table-column>
      <el-table-column
        label="旧机品类(物流)"
        prop="appraisalModel"
      ></el-table-column>
      <el-table-column
        label="旧机规格(物流)"
        prop="appraisalSpecification"
      ></el-table-column>
      <el-table-column
        label="铜管长度（物流）"
        prop="copperTubeLength"
      ></el-table-column>
      <el-table-column
        label="铝管长度（物流）"
        prop="aluminumTubeLength"
      ></el-table-column>
      <el-table-column
        label="大阀门(物流)"
        prop="actualBigValveName"
      ></el-table-column>
      <el-table-column
        label="小阀门(物流)"
        prop="actualSmallValveName"
      ></el-table-column>
      <el-table-column
        label="外机风叶(物流)"
        prop="actualExWindBladeName"
      ></el-table-column>
      <el-table-column
        label="外机电机(物流)"
        prop="actualExElectricalMachineryName"
      ></el-table-column>
      <el-table-column
        label="内机风叶(物流)"
        prop="actualInWindBladeName"
      ></el-table-column>
      <el-table-column
        label="内机电机(物流)"
        prop="actualInElectricalMachineryName"
      ></el-table-column>
      <el-table-column
        label="内机面板(物流)"
        prop="actualInternalPanelName"
      ></el-table-column>
      <el-table-column
        label="外机外罩(物流)"
        prop="actualExCoverName"
      ></el-table-column>
      <el-table-column
        label="外机顶板/底板(物流)"
        prop="actualExBoardName"
      ></el-table-column>
      <el-table-column
        label="电源线(物流)"
        prop="actualPowerLineName"
      ></el-table-column>
    </el-table>
    </div>
  </div>
</template>

<script>
import { settlementExportDetail } from "@/api/oldForNew";
export default {
  name: "searchOldSettlementDetail",
  components: {},
  data() {
    return {
      params: {
        salePlatformType: this.$route.query.salePlatformType,
        transportCompanyNo: this.$route.query.transportCompanyNo,
        regionNo: this.$route.query.regionNo,
        startAppraisalTime: this.$route.query.startAppraisalTime
          ? this.$route.query.startAppraisalTime + " 00:00:00"
          : "",
        endAppraisalTime: this.$route.query.endAppraisalTime
          ? this.$route.query.endAppraisalTime + " 23:59:59"
          : "",
        sourceWorkOrderNo: this.$route.query.sourceWorkOrderNo|| null,
        sendBackOrderId: this.$route.query.sendBackOrderId || null,
        settlementStatus: 1,
        startRecoveryCompleteDate: this.$route.query.startRecoveryCompleteDate
          ? this.$route.query.startRecoveryCompleteDate + " 00:00:00"
          : "",
        endRecoveryCompleteDate: this.$route.query.endRecoveryCompleteDate
          ? this.$route.query.endRecoveryCompleteDate + " 23:59:59"
          : "",
        startCreatedDate: this.$route.query.startCreatedDate
          ? this.$route.query.startCreatedDate + " 00:00:00"
          : "",
        endCreatedDate: this.$route.query.endCreatedDate
          ? this.$route.query.endCreatedDate + " 23:59:59"
          : "",
      },
      list: [
        // {
        //   sourceWorkOrderNo: '是我的粉丝的粉丝',
        //   serviceTypeName: '是我的粉丝的粉丝',
        //   oldInternalBarcode: '是我的粉丝的粉丝',
        //   oldExternalBarcode: '是我的粉丝的粉丝',
        //   sendBackOrderId: '是我的粉丝的粉丝',
        //   recoveryCompleteDateName: '是我的粉丝的粉丝',
        //   salePlatformName: '是我的粉丝的粉丝',
        //   outletsNo: '是我的粉丝的粉丝',
        //   transportCompany: '是我的粉丝的粉丝',
        //   warehouseName:  '是我的粉丝的粉丝',
        //   warehouseAddrProvName: '是我的粉丝的粉丝',
        //   warehouseAddrCityName: '是我的粉丝的粉丝',
        //   appraisalBrand: '是我的粉丝的粉丝',
        //   appraisalModel: '是我的粉丝的粉丝',
        //   appraisalSpecification: '是我的粉丝的粉丝',
        //   copperTubeLength: '是我的粉丝的粉丝',
        //   aluminumTubeLength: '是我的粉丝的粉丝',
        //   actualBigValveName: '是我的粉丝的粉丝',
        //   actualSmallValveName: '是我的粉丝的粉丝',
        //   actualExWindBladeName: '是我的粉丝的粉丝',
        //   actualExElectricalMachineryName: '是我的粉丝的粉丝',
        //   actualInWindBladeName: '是我的粉丝的粉丝',
        //   actualInElectricalMachineryName: '是我的粉丝的粉丝',
        //   actualInternalPanelName: '是我的粉丝的粉丝',
        //   actualExCoverName: '是我的粉丝的粉丝',
        //   actualExBoardName: '是我的粉丝的粉丝',
        //   actualPowerLineName: '是我的粉丝的粉丝',
        // }
      ],
      printFlag: true,
      listLoading: false
    };
  },
  mounted() {
    console.log('mounted search-old-settlement-detail>>>>>>>>')
    this.getPrintDetail();
    this.printDetail();
  },
  methods: {
    async getPrintDetail() {
      console.log('dasd',this.$route)
      let { statusCode, data } = await settlementExportDetail(this.params);
      if (statusCode === 200) {
        this.list = data;
        // this.printDetail();
      } else {
        this.$message.warning({
          message: "暂无结算单数据"
        });
      }
    },
    printDetail() {
      //获取原有页面的html内容
      let timer = setTimeout(() => {
        let oldStr = window.document.body.innerHTML;
        //根据id获取打印的html内容
        let newStr = document.getElementById("main").innerHTML;
        //html页面内容赋值
        window.document.body.innerHTML = newStr;
        //调用打印弹窗
        // window.print();
        // if (this.printFlag) {
        //   this.printFlag = false;
        //   this.$router.push({
        //     path: "/oldForNewService/searchOld"
        //   });
        // } else {
        //   //页面内容还原
        //   window.document.body.innerHTML = oldStr;
        //   // window.location.reload()
        // }
        // //打印完成后重新加载页面
        // window.location.reload();
        clearTimeout(timer);
      }, 500);
    },
    //返回
    goReturn() {
      this.$router.back(-1);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.search-old-settlement-detail {
  border-collapse: collapse;
  width: 100%;
}

/deep/ .el-table__header-wrapper table,
/deep/ .el-table__body-wrapper table {
  width: 100% !important;
}

/deep/ .el-table__body,
/deep/ .el-table__footer,
/deep/ .el-table__header {
  table-layout: auto;
}

/deep/ .el-table__empty-block,
/deep/ .el-table__body {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/searchOldSettlementDetail.vue